import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import classes from './TotalRevenueCard.module.scss';
import { GET_REVENUE_REQUEST } from '../../../../../../redux/actions';
import { perfomanceHighlightsSelector } from '../../../../../../redux/selectors/perfomanceHighlightsSelector';
import { totalRevenueSelector } from '../../../../../../redux/selectors/revenueSelector';
import {
  L12M,
  L3060D,
  N30D,
  L30D,
} from '../../../../../../utils/constants/filterConstants';
import { Highlight } from '../../../../../common/BasicHighlight/BasicHighlight';
import { Divider } from '@mui/material';
import { isMobileModeSelector } from '../../../../../../redux/selectors/appStatusSelector';
import { performancePagePeriodSelector } from '../../../../../../redux/selectors/performancePageSelector';

export const TotalRevenueCard = () => {
  const dispatch = useDispatch();
  const period = useSelector(performancePagePeriodSelector);
  const previousPeriod = period === N30D ? L12M : L3060D;

  const data = useSelector(perfomanceHighlightsSelector(period));
  const previousData = useSelector(
    perfomanceHighlightsSelector(previousPeriod)
  );

  const { netReservationIncome } = data || {};
  const { netReservationIncome: previousNetReservationIncome } =
    previousData || {};

  const totalRevenue = useSelector(totalRevenueSelector);
  const isMobileView = useSelector(isMobileModeSelector);

  useEffect(() => {
    dispatch({
      type: GET_REVENUE_REQUEST,
      payload: { param: period },
    });
  }, [dispatch, period]);

  return (
    <div className={classes.cardContainer}>
      <div className={classes.cardHeader}>
        <h4>Revenue</h4>
      </div>
      <div className={classes.cardBody}>
        {netReservationIncome !== 0 && (
          <Highlight
            className={classes.highlight}
            label='Net Reservation Income:'
            currency
            reverse
            value={netReservationIncome}
            previousValue={previousNetReservationIncome}
            showDynamicIndicator={period !== N30D && period !== L30D}
          />
        )}
        <Divider orientation={isMobileView ? 'horizontal' : 'vertical'} />
        {totalRevenue && (
          <Highlight
            className={classes.highlight}
            changeValueColor
            label='All Time Income:'
            currency
            reverse
            value={totalRevenue}
            showDynamicIndicator={false}
          />
        )}
      </div>
    </div>
  );
};
